Vendd.Scripts.load(function () {

    function ApiError(message, response) {
        this.name = this.constructor.name;
        this.message = message;
        this.response = response;
        this.stack = (new Error()).stack;
    }
    ApiError.prototype = new Error;
    
    var routes = {};

    _defaultOptions = {
        type: "POST",
        xhrFields: { withCredentials: true },
        beforeSend: function() { }
    };

    const chainFunction = function(originalFunction, callback) {

        return function() {
            
            originalFunction.apply(this, arguments);
            callback.apply(this, arguments);

        };
        
    }

    var Api = function() {

    };

    Api.prototype.init = function() {

        return Q.Promise(function (resolve, reject) {

            var domain = document.location.hostname;
           
            routes['site'] = location.protocol + '//' + domain;

            if (LhApp.Context.IsInLineAdminEnabled && LhApp.Context.InLineAdminEndpoint.length > 0) {
                routes['admin'] = LhApp.Context.InLineAdminEndpoint + '/vendd';
            } else {
                routes['admin'] = location.protocol + '//' + domain + '/vendd';
            }
            
            resolve();

        });

    };

    /**
     * Builds a full URI given a specific route and path.
     * @param {String} route A string containing the specified route.
     * @param {String} path A string containing the specified path.
     * @return {String}
     */
    Api.prototype.path = function(route, path) {

        if (!routes[route.toLowerCase()])
        {
            throw new Error('api route not found: ' + route);
        }
        
        if (path && !path.startsWith('/'))
        {
            path = '/' + path;
        }
        
        return routes[route.toLowerCase()] + path;
    };

    /**
     * Perform an asynchronous HTTP (Ajax) request.
     * @param {String} url A string containing the URL to which the request is sent.
     * @param {Object} data Data to be sent to the server. If the HTTP method is one that cannot have an entity body, such as GET, the data is appended to the URL.
     * @param {Object} options A set of key/value pairs that configure the Ajax request. All settings are optional.
     * @return {Promise}
     */
    Api.prototype.call = function(url, data, options) {

        var _options = _.extend({}, _defaultOptions, options || {}, {
            url: url
        });

        if(!!data) {

            _options.dataType = _options.dataType || 'json';
            _options.contentType =  _options.contentType || 'application/json; charset=UTF-8';

            _options.data = typeof data === 'string' ? data : JSON.stringify(data);

            _options.beforeSend = typeof _options.language === 'string' && _options.language.length === 2
                ? chainFunction(_options.beforeSend, function(xhr) { xhr.setRequestHeader("language", _options.language) })
                : _options.beforeSend;

        }
        
        return Q($.ajax(_options))
            .then(function(response) {

                if(typeof response.success === 'boolean')
                {
                    if(response.success != true)
                    {
                        throw new ApiError("Api Error", response);
                    }
                    
                    return response.data;
                }

                return response;

            })
            .then(null, function(response) {
                
                var _error = response instanceof Error
                    ? response
                    : new ApiError("Api Error", response.responseJSON || response.responseText);
                
                Vendd.logger.log(_error);

                throw _error;

            });

    };

    var Vendd = window.Vendd || {};
    Vendd.api = new Api();

});